import { render, staticRenderFns } from "./fsTableHeadItem.vue?vue&type=template&id=0768c007&scoped=true"
import script from "./fsTableHeadItem.vue?vue&type=script&lang=js"
export * from "./fsTableHeadItem.vue?vue&type=script&lang=js"
import style0 from "./fsTableHeadItem.vue?vue&type=style&index=0&id=0768c007&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0768c007",
  null
  
)

export default component.exports